import React from "react";
import { isDeviceVesta, VelavuDevice } from "velavu-js-api";
import TabTagCellular from "./tab-tag-cellular";
import TabTagDFU from "./tab-tag-dfu";
import TabTagEnvironment from "./tab-tag-environment";
import TabTagGeneral from "./tab-tag-general";
import TabTagLocation from "./tab-tag-location";
import * as styles from "./tab-tag.module.scss";
import { useHasPermission } from "../sign-in-context/sign-in-context";

export default function TabTag(props: {
	tag: VelavuDevice;
	onClickMap?: () => void;
}) {
	const canReadDFU = useHasPermission("dfu:read");

	return (
		<div className={styles.container}>
			{/* General tag information */}
			<TabTagGeneral tag={props.tag} onClickMap={props.onClickMap} />

			{/* Cellular information */}
			<TabTagCellular className={styles.expandMenu} tag={props.tag} />

			{/* Location information */}
			<TabTagLocation className={styles.expandMenu} tag={props.tag} />

			{/* Environment information */}
			<TabTagEnvironment className={styles.expandMenu} tag={props.tag} />

			{/* Device firmware update information */}
			{canReadDFU && isDeviceVesta(props.tag) && props.tag.config && (
				<TabTagDFU className={styles.expandMenu} tag={props.tag} />
			)}
		</div>
	);
}
